
export function ProcessSection() {
  return (
    <section id="como-funciona" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Como funciona nosso serviço?</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Processo transparente e eficiente do diagnóstico ao laudo final
          </p>
        </div>
        
        <div className="max-w-6xl mx-auto">
          {/* Mobile Version */}
          <div className="lg:hidden space-y-8">
            <div className="relative animate-fade-in-up">
              <div className="flex items-start gap-4">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 rounded-full bg-blue-800 flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">01</div>
                  <div className="w-1 h-full min-h-[100px] bg-gradient-to-b from-blue-800 to-blue-600 mt-2"></div>
                </div>
                <div className="flex-1 bg-white border-2 border-slate-200 rounded-xl p-6 hover:border-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl">
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-search-line text-2xl text-blue-800"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">Identificação do Vazamento</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Utilizamos equipamentos modernos como geofone eletrônico, detector de gases e termografia para localizar o vazamento com precisão milimétrica.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="relative animate-fade-in-up">
              <div className="flex items-start gap-4">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 rounded-full bg-blue-800 flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">02</div>
                  <div className="w-1 h-full min-h-[100px] bg-gradient-to-b from-blue-800 to-blue-600 mt-2"></div>
                </div>
                <div className="flex-1 bg-white border-2 border-slate-200 rounded-xl p-6 hover:border-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl">
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-tools-line text-2xl text-blue-800"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">Abertura Pontual e Reparo</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Realizamos abertura mínima somente onde necessário, executamos o reparo com materiais de qualidade e fechamos tudo deixando o local limpo.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="relative animate-fade-in-up">
              <div className="flex items-start gap-4">
                <div className="flex flex-col items-center">
                  <div className="w-16 h-16 rounded-full bg-blue-800 flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">03</div>
                </div>
                <div className="flex-1 bg-white border-2 border-slate-200 rounded-xl p-6 hover:border-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl">
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                    <i className="ri-file-text-line text-2xl text-blue-800"></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">Laudo Técnico</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Emitimos laudo técnico completo com fotos, descrição do serviço e aceito pela SABESP para comprovação e possível abatimento na conta.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Desktop Version */}
          <div className="hidden lg:block relative">
            <div className="absolute top-8 left-0 right-0 h-1 bg-gradient-to-r from-blue-800 via-blue-800 to-blue-800"></div>
            
            <div className="grid grid-cols-3 gap-8">
              <div className="relative animate-fade-in-up">
                <div className="flex justify-center mb-8">
                  <div className="w-16 h-16 rounded-full bg-blue-800 flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10 relative">01</div>
                </div>
                <div className="relative bg-white border-2 border-slate-200 rounded-xl p-8 hover:border-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl group">
                  <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6 mx-auto group-hover:bg-blue-800 group-hover:scale-110 transition-all duration-300">
                    <i className="ri-search-line text-2xl text-blue-800 group-hover:text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center group-hover:text-blue-800 transition-colors">Identificação do Vazamento</h3>
                  <p className="text-slate-600 leading-relaxed text-center">
                    Utilizamos equipamentos modernos como geofone eletrônico, detector de gases e termografia para localizar o vazamento com precisão milimétrica.
                  </p>
                </div>
              </div>
              
              <div className="relative animate-fade-in-up">
                <div className="flex justify-center mb-8">
                  <div className="w-16 h-16 rounded-full bg-blue-800 flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10 relative">02</div>
                </div>
                <div className="relative bg-white border-2 border-slate-200 rounded-xl p-8 hover:border-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl group">
                  <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6 mx-auto group-hover:bg-blue-800 group-hover:scale-110 transition-all duration-300">
                    <i className="ri-tools-line text-2xl text-blue-800 group-hover:text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center group-hover:text-blue-800 transition-colors">Abertura Pontual e Reparo</h3>
                  <p className="text-slate-600 leading-relaxed text-center">
                    Realizamos abertura mínima somente onde necessário, executamos o reparo com materiais de qualidade e fechamos tudo deixando o local limpo.
                  </p>
                </div>
              </div>
              
              <div className="relative animate-fade-in-up">
                <div className="flex justify-center mb-8">
                  <div className="w-16 h-16 rounded-full bg-blue-800 flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10 relative">03</div>
                </div>
                <div className="relative bg-white border-2 border-slate-200 rounded-xl p-8 hover:border-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl group">
                  <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6 mx-auto group-hover:bg-blue-800 group-hover:scale-110 transition-all duration-300">
                    <i className="ri-file-text-line text-2xl text-blue-800 group-hover:text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4 text-center group-hover:text-blue-800 transition-colors">Laudo Técnico</h3>
                  <p className="text-slate-600 leading-relaxed text-center">
                    Emitimos laudo técnico completo com fotos, descrição do serviço e aceito pela SABESP para comprovação e possível abatimento na conta.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}